class DiscountCodeForm extends HTMLElement {
    connectedCallback() {
        this.form = this.querySelector("#discount-input-form");
        this.discountInputField = this.querySelector("#discount-code");
        this.discountSubmit = this.querySelector("[data-submit]");

        this.init();
        this.refreshState();
    }

    init() {
        if ( this.form != null ) {
            this.form.addEventListener('submit', this.submitDiscountCode.bind(this) );
        }
    }

    async refreshState() {
        const currentCart = await getCartGraphQL();
        const codes = currentCart?.data?.cart?.discountCodes || [];

        if (codes.length > 0) {
            this.appliedCode = codes[0].code;
            this.discountInputField.value = this.appliedCode;
            this.discountSubmit.value = "REMOVE";
            this.discountSubmit.dataset.action = "remove";
        } else {
            this.appliedCode = null;
            this.discountInputField.value = "";
            this.discountSubmit.value = "APPLY";
            this.discountSubmit.dataset.action = "apply";
        }
    }

    async submitDiscountCode(event) {
        event.preventDefault();
        // Return if no code is entered and action is not remove
        if ( this.discountInputField.value.trim() === "" && this.discountSubmit.dataset.action !== "remove" ) {
            return;
        }

        const action = this.discountSubmit.dataset.action;

        if (action === "remove") {
            await applyCartDiscountCodes("2025-07", [], true);
            return;
        }
        
        const currentCart = await getCartGraphQL();
        const discountCodes = currentCart.data.cart.discountCodes;
        const discountCodesToSend = [];
        for (let i = 0; i < discountCodes.length; i++) {
            discountCodesToSend.push(discountCodes[i].code);
        }

        discountCodesToSend.push(this.discountInputField.value);

        await applyCartDiscountCodes("2025-07",discountCodesToSend,true);
    }
}

customElements.define( 'discount-code-form', DiscountCodeForm );

async function applyCartDiscountCodes( apiVersion = "2025-07" , discountCodes = [] , refreshCart = true ) {
    let applied = false;

    try {
        const discountQuery = `
        mutation cartDiscountCodesUpdate( $cartId: ID!, $discountCodes: [String!]! ) {
            cartDiscountCodesUpdate( cartId: $cartId, discountCodes: $discountCodes ) {
                cart {
                    id
                    appliedGiftCards {
                        id
                        lastCharacters
                    }
                    discountCodes {
                        applicable
                        code
                    }
                }
                userErrors {
                    field
                    message
                    code
                }
                warnings {
                    message
                    code
                    target
                }
            }
        }`;

        const cartToken = await getCartToken();
        const decodedCartToken = decodeURI(cartToken);

        const variables = {
            cartId: `gid://shopify/Cart/${decodedCartToken}`,
            discountCodes: discountCodes
        };

        const shop = window.Shopify.shop;
        const requestUrl = `https://${shop}/api/${apiVersion}/graphql.json`;
        const requestSettings = {
            method: "POST",
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({
                query: discountQuery,
                variables: variables
            })
        };
        
        const response = await fetch(requestUrl,requestSettings);
        const data = await response.json();

        if (data?.errors?.length > 0) {
            throw new Error( JSON.stringify(data.errors));
        } else {
            applied = true;
        }
    } catch (error) {
        console.error( error );
        console.log( '[Cart Discount Codes] Failed to apply discount codes to the cart! See reported error for details.' );
    }

    if (refreshCart) {
        try {
            document.dispatchEvent(new CustomEvent('cart:refresh'));
        } catch (error) {
            console.warn(error);
        }
    }

    return applied;
}

async function getCartGraphQL(apiVersion = "2025-07") {
    let graphqlCart = null;
    
    try {
        const cartQuery = `
            query GetCart( $cartId: ID! ) {
                cart(
                    id: $cartId
                ) {
                    id
                    totalQuantity
                    cost {
                        subtotalAmountEstimated
                        totalAmountEstimated
                        checkoutChargeAmount {
                            amount
                        }
                        subtotalAmount {
                            amount
                        }
                        totalAmount {
                            amount
                        }
                    }
                    appliedGiftCards {
                        lastCharacters
                        amountUsed {
                            amount
                        }
                        balance {
                            amount
                        }
                        presentmentAmountUsed {
                            amount
                        }
                    }
                    discountCodes {
                        applicable
                        code
                    }
                }
            }
        `;

        const cartToken = await getCartToken();
        const decodedCartToken = decodeURI( cartToken );
        const variables = {
            cartId: `gid://shopify/Cart/${decodedCartToken}`
        };

        const shop = window.Shopify.shop;
        const requestUrl = `https://${shop}/api/${apiVersion}/graphql.json`;
        const requestSettings = {
            method: "POST",
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({
                query: cartQuery,
                variables: variables
            })
        };
        
        const response = await fetch(requestUrl , requestSettings);
        const data = await response.json();

        if ( data?.errors?.length > 0 ) {
            throw new Error( JSON.stringify(data.errors));
        } else {
            graphqlCart = data;
        }
    } catch ( error ) {
        console.error( error );
        console.log( '[Cart Discount Codes] Failed to get cart id for current cart token.' );
    }

    return graphqlCart;
}

async function getCartToken() {
    let token = null;

    try {
        const response = await fetch('/cart.json');
        const cart = await response.json();
        token = cart.token;
    } catch ( error ) {
        console.error( error );
        console.log( '[Cart Discount Codes] Failed to get cart token from /cart.json' );
    }

    return token;
}